<script>
import {computed, onMounted} from "vue";
import FormInput from "@/components/ui/FormInput.vue";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import {useUserSettings} from "@/composables/user-settings";
import {useOrdersStore} from "@/store/orders";
import {checkEmail, checkPhone} from "@/tools/validation.tools";

export default {
  name: "CheckoutContactData",
  components: {FormInput, PhoneInput},
  setup() {

    const userSettings = useUserSettings();
    const ordersStore = useOrdersStore();

    const checkoutData = computed( () => {
      return ordersStore.checkoutData
    })

    onMounted(() => {
      checkoutData.value.fio = (userSettings.first_name || '') + ' ' + (userSettings.last_name || '');
      checkoutData.value.email = userSettings.email;
      checkoutData.value.phone = userSettings.phone;
    })

    const emailError = computed(() => {
      return checkEmail(checkoutData.value.email, true)? '' : 'Неверный формат email';
    });

    const phoneError = computed(() => {
      return checkPhone(checkoutData.value.phone, true)? '' : 'Введите полный номер телефона';
    });

    return {
      checkoutData,
      emailError,
      phoneError,
    }
  }
}
</script>

<template>
  <div class="contactData">
    <div class="contactData__header">Контактная информация</div>
    <label class="contactData__textLabel">Номер телефона <span class="contactData__required">*</span></label>
    <phone-input v-model="checkoutData.phone" :error="phoneError"/>

    <label class="contactData__textLabel">ФИО <span class="contactData__required">*</span></label>
    <form-input v-model="checkoutData.fio" :name-only="true"/>

    <label class="contactData__textLabel">Почта<span class="contactData__required">*</span></label>
    <form-input v-model="checkoutData.email" :error="emailError"/>
  </div>
</template>

<style scoped lang="scss">
.contactData {
  text-align: left;
  width: 663px;
  font-size: 14px;
  font-weight: 400;
  font-family: var(--cd-default-font);

  &__header {
    font-family: var(--cd-default-font);
    font-weight: 400;
    font-size: 26px;
  }
  &__textLabel {
    padding: 24px 10px 10px;
    display: block;
  }

  &__textLabel--muted {
    display: block;
    color: var(--cd-text-muted);
    margin: 20px 0px;
  }
  &__required {
    color: var(--cd-danger);
    margin-left: 3px;
  }

}
</style>
